module.exports = __webpack_public_path__ + "img/left_4.b5000de1.png";